import React, { useRef } from 'react';
import { X, BookOpen, Upload } from 'lucide-react';
import '../../css/book_edit_modal.css';

const BookEditModal = ({ 
  isEditModalOpen, 
  selectedBook,
  newTitle, 
  setNewTitle, 
  newDescription, 
  setNewDescription, 
  isCusomImageToggled, 
  handleIsCustomImageToggled, 
  handleImageUpload,
  handleSaveTitle,
  handleCloseEditModal 
}) => {
  const fileInputRef = useRef(null);

  if (!isEditModalOpen || !selectedBook) return null;

  const coverImage = (selectedBook.use_custom_image && selectedBook.uploaded_image_b64 !== "")
    ? selectedBook.uploaded_image_b64
    : selectedBook.imageLinks !== "{}"
      ? JSON.parse(selectedBook.imageLinks).thumbnail
      : null;

  return (
    <div className="book-details-modal" onClick={handleCloseEditModal}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Desktop two-panel layout */}
        <div className="modal-panels edit-modal-panels">
          {/* Left: Cover Panel */}
          <div className="modal-cover-panel edit-cover-panel">
            <div className="modal-cover-image">
              {coverImage ? (
                <img src={coverImage} alt={selectedBook.title} />
              ) : (
                <BookOpen size={48} className="modal-cover-placeholder-icon" />
              )}
            </div>
            {isCusomImageToggled ? (
              <>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  capture="camera"
                  onChange={handleImageUpload}
                  className="edit-file-input-hidden"
                />
                <button
                  className="edit-upload-btn"
                  onClick={() => fileInputRef.current?.click()}
                >
                  <Upload size={14} />
                  <span>Upload New Image</span>
                </button>
              </>
            ) : null}
          </div>

          {/* Right: Detail Panel */}
          <div className="modal-detail-panel edit-detail-panel">
            <div className="modal-close-row">
              <button className="modal-close-btn" onClick={handleCloseEditModal} aria-label="Close">
                <X size={20} />
              </button>
            </div>

            <div className="modal-title-section">
              <h2 className="modal-book-title">Edit Book</h2>
              <span className="modal-book-author" style={{ color: 'var(--color-text-muted)' }}>
                Update the details for this book
              </span>
            </div>

            <div className="modal-divider" />

            <div className="edit-form-area">
              <div className="edit-field">
                <label className="edit-field-label">TITLE</label>
                <input
                  type="text"
                  className="edit-field-input"
                  value={newTitle}
                  onChange={(e) => setNewTitle(e.target.value)}
                />
              </div>

              <div className="edit-field">
                <label className="edit-field-label">DESCRIPTION</label>
                <textarea
                  className="edit-field-textarea"
                  value={newDescription}
                  onChange={(e) => setNewDescription(e.target.value)}
                  rows={4}
                />
              </div>

              <div className="edit-toggle-row">
                <span className="edit-field-label">USE CUSTOM IMAGE</span>
                <button
                  className={`edit-toggle ${isCusomImageToggled ? 'is-active' : ''}`}
                  onClick={handleIsCustomImageToggled}
                  aria-label="Toggle custom image"
                >
                  <span className="edit-toggle-dot" />
                </button>
              </div>
            </div>

            <div className="modal-divider" />

            <div className="edit-actions">
              <button className="modal-action-btn modal-action-edit" onClick={handleSaveTitle}>
                Save Changes
              </button>
              <button className="modal-action-btn modal-action-collection" onClick={handleCloseEditModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>

        {/* Mobile fallback */}
        <div className="modal-mobile-only edit-mobile-fallback">
          <h3>Edit Book</h3>
          <div className="input-group">
            <label>Title:</label>
            <input
              className='search-box-add'
              type="text"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
            />
          </div>
          <div className="input-group">
            <label>Description:</label>
            <input
              className='search-box-add'
              value={newDescription}
              onChange={(e) => setNewDescription(e.target.value)}
            />
          </div>
          <div className="input-group">
            <label>Custom Image:</label>
            <button className='search-button-2' onClick={handleIsCustomImageToggled}>
              {isCusomImageToggled ? "Yes" : "No"}
            </button>
          </div>
          {isCusomImageToggled ? (
            <div className="input-group">
              <label>Upload Photo:</label>
              <input
                className="search-box-add"
                type="file"
                accept="image/*"
                capture="camera"
                onChange={handleImageUpload}
              />
            </div>
          ) : null}
          <div className="edit-modal-buttons">
            <button className='search-button' onClick={handleSaveTitle}>Save</button>
            <button className='search-button' onClick={handleCloseEditModal}>Close</button>
          </div>
        </div>
      </article>
    </div>
  );
};

export default BookEditModal;
